import React from 'react';
import CategoryPage from '../components/CategoryPage';
import { redeSocialProjects } from '../data/mock';
import { TrendingUp } from 'lucide-react';

const RedeSocial = () => (
  <CategoryPage
    icon={TrendingUp}
    title="Rede Social"
    subtitle="Ritmo · Gancho · Retenção. Reels em formato vertical pensados para o feed — corte rápido, leitura imediata e identidade visual da marca."
    projects={redeSocialProjects}
    tapeColor="rgba(170,205,185,0.45)"
    tapeSide="right"
  />
);

export default RedeSocial;
